export default "__VITE_ASSET__4db83e56__"